// Temporary component-local copy for the reports mockup; no backend translation keys.
export default {
    en: {
        reports: 'Reports',
        actions: 'Product actions',
        documentType: 'Document type',
        declaration: 'Declaration of Conformity',
        statement: 'Compliance statement',
        technical: 'Technical documentation',
        regulations: 'Regulations',
        selectRegulations: 'Select regulations',
        createReport: 'Create report',
        noExistingDocument: 'There is no existing document for selected parameters',
        notImplemented: 'No reports have yet been implemented',
        loadFailed: 'Could not load report parameters. Please try again.',
        backToProduct: 'Back to product',
    },
    sv: {
        reports: 'Rapporter',
        actions: 'Produktåtgärder',
        documentType: 'Dokumenttyp',
        declaration: 'Försäkran om överensstämmelse',
        statement: 'Utlåtande om efterlevnad',
        technical: 'Teknisk dokumentation',
        regulations: 'Regelverk',
        selectRegulations: 'Välj regelverk',
        createReport: 'Skapa rapport',
        noExistingDocument: 'Det finns inget befintligt dokument för de valda parametrarna',
        notImplemented: 'Inga rapporter har implementerats ännu',
        loadFailed: 'Det gick inte att läsa in rapportparametrarna. Försök igen.',
        backToProduct: 'Tillbaka till produkten',
    },
}
